import React, { useMemo } from "react";

import connect from "../../../../../../i18n/connect";
import useIsDesktop from "../../../hooks/useIsDesktop";
import { getPeriodToggleOptions } from "../../../../../../lib/Plans";
import { ToggleSelect } from "./ToggleSelect";

const ToggleSelectPlan = ({
  translate,
  plan,
  setPlan,
  allowedPeriods = []
}) => {
  const isDesktop = useIsDesktop();

  const options = useMemo(() => {
    const yearlyTooltipLabel = translate(
      "lp_plan-table_yearly_toggle-select_tooltip"
    );

    return getPeriodToggleOptions({
      allowedPeriods,
      translate,
      yearlyTooltip: {
        tooltipTop: !isDesktop ? yearlyTooltipLabel : undefined,
        tooltipBottom: isDesktop ? yearlyTooltipLabel : undefined
      }
    });
  }, [allowedPeriods, isDesktop, translate]);

  return <ToggleSelect options={options} value={plan} onChange={setPlan} />;
};

export default connect()(ToggleSelectPlan);
